import { CONTROL } from '../../../../components';
export var VM_WARE_VIRTUAL_MACHINES_BACKUP_FORM_CONFIG = {
  ui: ['vmWareVirtualMachinesBackup'],
  controls: {
    vmWareVirtualMachinesBackup: {
      type: CONTROL.Table,
      accessorKey: 'vmWareVirtualMachinesBackup',
      defaultValue: {
        backupVM: 0,
        localStorage: 0,
        remoteStorage: 0
      },
      rows: [{
        label: 'Резервное копирование ВМ',
        accessorKey: 'backupVM',
        uiProps: {
          min: 0,
          max: 50000,
          postfix: 'Шт'
        }
      }, {
        label: 'Локальное хранилище',
        accessorKey: 'localStorage',
        uiProps: {
          min: 0,
          max: 2044977,
          postfix: 'ГБ'
        },
        labelTooltip: 'Резервные копии хранятся на основной площадке'
      }, {
        label: 'Удаленное хранилище',
        accessorKey: 'remoteStorage',
        uiProps: {
          min: 0,
          max: 2044977,
          postfix: 'ГБ'
        },
        labelTooltip: 'Резервные копии хранятся на площадке, удаленной от основного ЦОДа. Рекомендуется выбирать удаленный репозиторий для повышения уровня безопасности'
      }]
    }
  }
};